// extracted by mini-css-extract-plugin
export default {"services":"RenewPriceWithOption-services_IrcH5","priceBox":"RenewPriceWithOption-priceBox_b2M_J"};